export default "__VITE_ASSET__FXYd404G__"